import { queryClient } from "@/queryClient"
import api from "@/services/api"
import { BASE_PORTAL_EMAIL_ADDRESSES_QUERY_KEY } from "@/services/queryKeys"

export const requestPortalLoginLink = async (
  email: string
) => {
  await api.post("/auth/portal/device-request-login-link", {
    body: { email },
  })

  // Account may be created for new email
  queryClient.refetchQueries([
    BASE_PORTAL_EMAIL_ADDRESSES_QUERY_KEY,
  ])
}
